export default {"src":"/_next/static/media/bookmark_tabs_color.c3b6773b.svg","height":32,"width":32};